import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactSelect from '../../../components/uiComponent/select';
import { Box, Stack, Typography } from '@mui/material';
import { AiOutlineDelete, AiOutlineSwap } from 'react-icons/ai';
import { IoReload } from 'react-icons/io5';
import { BiSolidEdit } from 'react-icons/bi';
import { FaChevronDown } from 'react-icons/fa6';
import { RiCalendarLine } from 'react-icons/ri';
import { LuUpload } from 'react-icons/lu';
import { BsPrinter } from 'react-icons/bs';
import { Popover, Tooltip, Spin, notification, DatePicker, Select, Upload, message, Popconfirm, Radio } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { ceil, findIndex, debounce, trim, isEmpty, capitalize, isArray } from 'lodash';
import dayjs from 'dayjs';
import moment from 'moment';

import productLabel from '../../../utils/print-labels/productLabel';
import { isFnskuLabelSuppressed, notifyFnskuLabelSuppressed } from '../../logistics/orders/warehouse/shipping/steps/step2/packNowLabelHelpers';
import ProductImg from '../../../assets/images/newImages/nestle.svg';
import WarningInfoIcon from '../../../assets/images/newImages/info-icon.svg';
import InfoIcon from '../../../assets/images/newImages/info-icon-blue.svg';
import importIcon from '../../../assets/images/newImages/import-xlsx.svg';
import CSVFile from '../../../assets/icons/csv-file.svg';
import FileIcon from '../../../assets/icons/file-icon.svg';
import uploadIcon from '../../../assets/images/newImages/upload-icon.svg';

import Pagination from '../../../components/pagination/index';
import AgGrid from '../../../components/ag-grid-table/index';
import WarningIcon from '../../../assets/icons/warning-modal-icon.svg';
import DeleteIcon from '../../../assets/icons/delete-circle-icon.svg';

import SearchInput from '../../../components/uiComponent/inputs/searchinput/index';
import Modal from '../../../components/uiComponent/modal/index';
import Button from '../../../components/uiComponent/button/index';
import Badge from '../../../components/uiComponent/bages/index.js';
import Input from '../../../components/uiComponent/inputs/input/index';
import AddSkuDrawer from './addSkuDrawer.js';
import MoveItemsModal from '../../logistics/orders/warehouse/shipping/steps/step2/MoveItemsModal.js';

import { ModalWrapper } from '../../purchase-order/po-warehouse-details/custom-drawer/style.js';
import { PoDetailsWrapper } from '../../purchase-order/po-details/style.js';
import { CreateInventoryWorkOrderWrapper, BulkExpiryContentWrapper, AddressModalWrapper } from './style';
import WorkRowDetails from './workRowDetails.js';

import XLSX from 'xlsx';

import {
  GetWorkOrderDetails,
  GetOrderItems,
  GetGatedStatus,
  UpdateShipQuantity,
  GetAllShipFromAddress,
  UpdateOrderDetails,
  DeleteOrderItem,
  updateState,
  removeDataEntry,
  setUpdatedSkuStatus,
  UpdateOrderItem,
  updateExpiryDate,
  CreateInboundPlan,
  appendErrorMessages,
  UpdatePrepCategory,
  editPrepCategory,
  ProcessBulkWorkOrderItem,
  BulkDeleteOrderItems,
  UpdatePrepOwner,
  editPrepOwner,
  editLabelOwner,
  UpdateLabelOwner,
  updateShipQty,
  updateGridShippedQty,
  EditBulkOrderItemExpiry,
  SyncSkuFullInfo,
  MoveOrderItems,
  GetDraftWorkOrdersForMove
} from '../../../slices/work-orders';


import { VALID_DATE } from '../../../utils/regex';
import InventoryWrapper from '../style.js';
import { GetPresignedUrl } from '../../../slices/aws-services.js';
import CustomAntdModal from '../../../components/uiComponent/modal/antd-modal.js';
import { AddressSelector } from '../../../components/uiComponent/customOptionSelect/index.js';
import AddressModal from './inbound-plan/addressModal.js';
import { setItem } from '../../../slices/auth.js';

const { Option } = Select;

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
  suppressMenu: true,
  suppressMovable: true
};

export const PREP_CATEGORIES = [
  'ADULT',
  'BABY',
  'FC_PROVIDED',
  'FRAGILE',
  'GRANULAR',
  'HANGER',
  'LIQUID',
  'PERFORATED',
  'SET',
  'SHARP',
  'SMALL',
  'TEXTILE',
  'UNKNOWN',
  'NONE'
];

const PREP_OWNER = [
  'AMAZON',
  'SELLER',
  'NONE'
];

const gridOptions = {
  stopEditingWhenCellsLoseFocus: true
};

let gridApi = null;
let gridColumnApi;
const CreateInventoryWorkOrder = () => {
  const { workOrderId } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState({ pageSize: 100, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '' });
  const [workOrderDetails, setWorkOrderDetails] = useState({ previous: {}, current: {} });
  const [isDelete, setIsDelete] = useState(false);
  const [isDeleteBulk, setIsDeleteBulk] = useState(false);
  const [addSku, setAddSku] = useState(false);
  const [rowIndex, setRowIndex] = useState(-1);
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [rowIndexesForGatedStatus, setRowIndexesForGatedStatus] = useState([]);
  const [rowIndexesForExpiryDate, setRowIndexesForExpiryDate] = useState([]);
  const [rowIndexesForPrepCategory, setRowIndexesForPrepCategory] = useState([]);
  const [rowIndexesForPrepOwner, setRowIndexesForPrepOwner] = useState([]);
  // Keyed by SKU id (not row index): rows can refetch/reorder while a save is in flight, and an
  // index-based guard would then disable the WRONG row's dropdown.
  const [savingLabelOwnerSkuIds, setSavingLabelOwnerSkuIds] = useState([]);
  const [uploadFile, setUploadFile] = useState({});
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [bulkExpiry, setBulkExpiry] = useState(false);
  const [isBulkExpiry, setIsBulkExpiry] = useState(false);
    const [processWorkOrderLoading, setProcessWorkOrderLoading] = useState(false);
    const [selectedRowsCount, setSelectedRowsCount] = useState(0);
    const [bulkExpiryDate, setBulkExpiryDate] = useState('');
    const [bulkExpiryLoading, setBulkExpiryLoading] = useState(false);
    const [addressModal, setAddressModal] = useState(false);
    const [addressIndex, setAddressIndex] = useState(-1);
    const [editWorkOrderItem, setEditWorkOrderItem] = useState({ id: '', key: '', value: '' });
  const [updatingShipQtyRowId, setUpdatingShipQtyRowId] = useState(null);
    const [newValue, setNewValue] = useState('');
    const [bulkDeleteRows, setBulkDeleteRows] = useState([]);

    const [showPrintModal, setShowPrintModal] = useState(false);
    const [printQty, setPrintQty] = useState(1);
    const [selectedItemForPrint, setSelectedItemForPrint] = useState(null);

    const [shipmentType, setShipmentType] = useState('SP');
    const [packingMethod, setPackingMethod] = useState('pack_now');
    const [isMove, setIsMove] = useState(false);

    const {
      fetchingWorkOrderDetails,
      fetchingOrderItems,
      syncingSkuFlags,
      orderItems,
      orderItemsCount,
      fetchingSkuGatedStatus,
      updatingShipQuantity,
      warehouseAddresses,
      fetchingWarehouseAddresses,
      updatingOrderDetails,
      deletingOrderItem,
    updatingOrderItem,
    creatingInboundPlan,
    updatingPrepCategory,
    bulkDeletingOrderItems,
    updatingPrepOwner,
    syncingSkuFullInfo,
    workOrderDetails: storeWorkOrderDetails,
    movingOrderItems,
    fetchingDraftWorkOrdersForMove,
    draftWorkOrdersForMove
  } = useSelector((state) => state.workOrders || {});
  const { currentUser } = useSelector((state) => state.auth || {});

  useEffect(() => {
    if (workOrderDetails?.current?.is_placement_options_saved) {
      navigate(`/placement-option/${workOrderId}`);
    }
  }, [workOrderDetails]);

  // Backfill prep_owner = 'SELLER' for newly added SKUs that landed in the grid with no owner.
  // The inbound-plan API reads from DB, so a null owner would fail validation.
  const defaultedPrepOwnerIds = useRef(new Set());
  useEffect(() => {
    if (!orderItems?.length) return;
    orderItems.forEach((item) => {
      if (!item?.prep_owner && !defaultedPrepOwnerIds.current.has(item.id)) {
        defaultedPrepOwnerIds.current.add(item.id);
        dispatch(UpdatePrepOwner({ skuId: item.id, prepOwner: 'SELLER' })).then(({ payload }) => {
          if (payload?.success) {
            dispatch(editPrepOwner({ value: 'SELLER', id: item.id }));
          }
        });
      }
    });
  }, [orderItems]);

  const {
    fetchingPlacementOptions,
    fetchingShipmentItems
  } = useSelector((state) => state.shipmentPlan);

  const mappedWarehouseAddresses = warehouseAddresses?.map(({
    wh_name,
    id,
    address_line_1,
    city,
    country,
    state_or_province,
    zipcode
  }) => ({
    value: id,
    label: `${wh_name || ''}, ${address_line_1 || ''}, ${city || ''}, ${state_or_province || ''} ${zipcode || ''}, ${country || ''}`
  })) || [];

  const { previous, current } = workOrderDetails || {};

  const {
    box_packing_information,
    label_owner,
    notes,
    order_name,
    order_type,
    status,
    address_id
  } = current || {};

  const { Dragger } = Upload;

  const handleFileUpload = async () => {
    setProcessWorkOrderLoading(true);
    let uploadedFile = {};
    if (!isEmpty(uploadFile)) {
      dispatch(setItem({
        field: 'showFileHeader',
        value: false
      }));
      await dispatch(GetPresignedUrl({ files: [uploadFile] })).then(({ payload }) => {
        if (!payload?.error) {
          uploadedFile = payload[0];
        }
      });
      if (uploadedFile) {
        await dispatch(ProcessBulkWorkOrderItem({ fileName: uploadedFile?.key, fileUrl: uploadedFile?.url, fileType: uploadedFile?.extension, workOrderId })).then(({ payload }) => {
          if (!payload?.error) {
            message.success('File Uploaded Successfully');
          } else {
            message.error('Error While Uploading File');
          }
          dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
            const { data } = payload || {};
            setWorkOrderDetails({ previous: data, current: data });
          });
          setUploadFile({});
          setPopoverVisible(false);
          refreshGridClick();
          setProcessWorkOrderLoading(false);
        });
      }
      dispatch(setItem({
        field: 'showFileHeader',
        value: true
      }));
    }
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    accept: ['.xlsx', '.xls', '.csv'],
    fileList: !isEmpty(uploadFile) ? [{ ...uploadFile, name: uploadFile.name, key: uploadFile.uid || uploadFile.name }] : [],
    onChange(info) {
      if (info.fileList.length === 0) {
        return;
      }
      const file = info.file;
      const fileExtension = file?.name?.split('.').pop();
      if (!['xls', 'xlsx', 'csv'].includes(fileExtension)) {
        message.error(`${file.name} upload failed. Only Excel and Csv files are allowed.`);
        return;
      }
      setUploadFile(file);
    },
    beforeUpload: () => false,
    onRemove: () => {
      setUploadFile({});
      return true;
    }
  };

  const handleEditClick = (e) => {
    const index = mappedWarehouseAddresses.findIndex(option => option.value === e?.value);
    setAddressIndex(index);
    setAddressModal(true);
  };

  const handleVisibleChange = (visible) => {
    setPopoverVisible(visible);
    setBulkExpiry(false);
  };
  const handleVisibleBulkExpiryChange = (visible) => {
    setBulkExpiry(visible);
  };
  const handleDeleteBulk = () => {
    if (bulkDeletingOrderItems) return;
    if (['Confirmed', 'In Progress', 'Done'].includes(status)) {
      notification.error({
        top: 65,
        message: 'Bulk Delete Order Items',
        description: 'You cannot delete order items in Confirmed or Processed status.'
      });
      return;
    }
    const selectedRows = gridApi.getSelectedRows();
    if (!orderItems?.length || selectedRows.length === 0) {
      notification.error({
        top: 65,
        message: 'Bulk Delete Order Items',
        description: 'Please select at least one row.'
      });
      return;
    }
    setBulkDeleteRows(selectedRows);
    setIsDeleteBulk(true);
    setBulkExpiry(false);
  };
  const handleBulkExpiry = () => {
    setIsBulkExpiry(true);
    setBulkExpiry(false);
  };

  const bulkExpiryContent = (
    <BulkExpiryContentWrapper>
      <ul className='bulk-expiry-list'>
        <li onClick={handleVisibleChange}><LuUpload /> <span>Import</span></li>
        <li onClick={() => handleExportAll()}><img src={CSVFile} /> <span>Export</span></li>
        <li onClick={handleBulkExpiry}><RiCalendarLine /> <span>Expiry</span></li>
        <li onClick={handleDeleteBulk} className='delete'><AiOutlineDelete /> <span>Delete</span></li>
      </ul>
    </BulkExpiryContentWrapper>
  );

  const content = (
    <InventoryWrapper style={{ width: 350 }} className='pt-0'>
      <Spin tip='Loading...' spinning={processWorkOrderLoading}>

        <p className="text-primary d-flex align-items-center gap-1">
          <a
            href="https://opulant-storage.s3.us-east-1.amazonaws.com/work-order-sample.xlsx"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary d-flex align-items-center gap-1"
          >
            <img src={InfoIcon} alt="info" />
            <span className="fs-12 fw-semibold">Download Sample File</span>
          </a>      </p>
        <Dragger maxCount={1} {...uploadProps} style={{ marginTop: 16, padding: 16, borderRadius: 8 }}>
          <p className="ant-upload-drag-icon">
            <img src={uploadIcon} alt='upload' />
          </p>
          <p className="ant-upload-text text-primary fs-14 fw-semibold text-decoration-underline">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single upload
          </p>
        </Dragger>

        <p className="text-grey d-flex align-items-center gap-1 mt-2">
          <img src={WarningInfoIcon} alt="warning" />
          <span className="fs-12 fw-semibold">Expiry date must be at least 105 days in future from current date</span>
        </p>

        <h6>Uploaded Files</h6>
        {
          !isEmpty(uploadFile) &&
          <div className="uploaded-file-container">
            <div key={uploadFile.uid} className="uploading-content-data">
              <div className="title">
                <img src={FileIcon} alt="File Icon" title="File Icon" />
                <span>{uploadFile.name}</span>
              </div>
              <AiOutlineDelete onClick={() => setUploadFile({})} style={{ cursor: 'pointer', color: 'red' }} />
            </div>
          </div>
        }
        <div className='d-flex gap-2 justify-content-end mt-3'>
          <Button
            text="Cancel"
            className="outlined mb-0"
            onClick={() => {
              setPopoverVisible(false);
              setUploadFile({});
            }
            }
          />
          <Button
            text={'Save'}
            disabled={isEmpty(uploadFile)}
            className="primary mb-0"
            onClick={handleFileUpload}
          />
        </div>
      </Spin>
    </InventoryWrapper>
  );

  useEffect(() => {
    dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
      const { data } = payload || {};
      // Only Draft work orders are editable here; once a plan is created the user belongs on /work-orders
      if (data?.status && data.status.toLowerCase() !== 'draft') {
        navigate('/work-orders', { replace: true });
        return;
      }
      setWorkOrderDetails({ previous: data, current: data });
    });

    dispatch(GetAllShipFromAddress());

    // Label owner + expiry-required flags come straight from seller_skus (kept current by the
    // nightly sync-prep-owner job) — no Amazon call on page load.
    dispatch(GetOrderItems({
      workOrderId,
      page,
      sortBy,
      filters
    }));
  }, []);

  const handleGetSkuGatedStatus = ({ skuId, index }) => {
    setRowIndexesForGatedStatus(rowIndexesForGatedStatus => [...rowIndexesForGatedStatus, index]);
    dispatch(GetGatedStatus(skuId))
      .then(({ payload }) => {
        if (payload?.success) {
          dispatch(setUpdatedSkuStatus({
            field: 'orderItems',
            index,
            value: payload?.skuStatus
          }));
        }
        setRowIndexesForGatedStatus(rowIndexesForGatedStatus => rowIndexesForGatedStatus.filter((rowIndex) => rowIndex !== index));
      });
  };

  const isValidFutureDate = (date) => {
    const [year, month, day] = date.split('-').map(Number);
    const inputDate = new Date(Date.UTC(year, month - 1, day));

    const minValidDate = new Date();
    minValidDate.setUTCHours(0, 0, 0, 0);
    minValidDate.setDate(minValidDate.getDate() + 105);

    return inputDate >= minValidDate;
  };

  const handleBulkExpiryDate = () => {
    if (bulkExpiryLoading) return;
    if (!bulkExpiryDate || (bulkExpiryDate.trim() === '') || !VALID_DATE.test(bulkExpiryDate)) {
      return notification.warning({
        message: 'Please enter a valid Expiry Date!',
        description: 'Valid Format: YYYY-MM-DD',
        top: 60
      });
    }
    if (!isValidFutureDate(bulkExpiryDate)) {
      return notification.warning({
        message: 'Expiry date must be at least 105 days in future from current date',
        top: 60
      });
    }
    setBulkExpiryLoading(true);
    dispatch(EditBulkOrderItemExpiry({
      work_order_id: workOrderId,
      data: { expiry_date: bulkExpiryDate }
    })).then(({ payload }) => {
      setBulkExpiryLoading(false);
      if (payload.success) {
        handleBulkExpiry();
        setIsBulkExpiry(false);
        setBulkExpiryDate('');
        dispatch(GetOrderItems({
          workOrderId,
          page,
          sortBy,
          filters
        }));
      }
    });
  };

  const handleExpiryDateUpdation = ({ expiryDate, data, index }) => {
    setRowIndexesForExpiryDate(rowIndexesForExpiryDate => [...rowIndexesForExpiryDate, index]);

    const { work_order_items_v2s } = data || {};
    const { expiry_date: oldExpiryDate, id: work_order_item_id } = work_order_items_v2s?.[0] || {};


    if (!expiryDate || (expiryDate.trim() === '') || (expiryDate === oldExpiryDate) || !VALID_DATE.test(expiryDate)) {
      setRowIndexesForExpiryDate(rowIndexesForExpiryDate => rowIndexesForExpiryDate.filter((rowIndex) => rowIndex !== index));
      return notification.warning({
        message: 'Please enter a valid Expiry Date!',
        description: 'Valid Format: YYYY-MM-DD',
        top: 60
      });
    }

    if (!isValidFutureDate(expiryDate)) {
      setRowIndexesForExpiryDate(rowIndexesForExpiryDate => rowIndexesForExpiryDate.filter((rowIndex) => rowIndex !== index));
      return notification.warning({
        message: 'Expiry date must be at least 105 days in future from current date',
        top: 60
      });
    }

    dispatch(UpdateOrderItem({
      work_order_item_id,
      data: { expiry_date: expiryDate }
    }))
      .then(({ payload }) => {
        const { success } = payload || {};
        if (success) {
          dispatch(updateExpiryDate({
            value: expiryDate,
            index
          }));
        }
        setRowIndexesForExpiryDate(rowIndexesForExpiryDate => rowIndexesForExpiryDate.filter((rowIndex) => rowIndex !== index));
      });
  };

  const handleSave = (id, key, value, oldValue, data) => {
    if (!id || !key) return;

    if (key === 'ship_quantity') {
      const parsedValue = parseInt(value, 10);
      if (isNaN(parsedValue) || parsedValue < 0 || String(value).trim() === '') {
        setEditWorkOrderItem({ id: '', key: '', value: '' });
        return notification.warning({
          message: 'Please enter a valid ship quantity!',
          top: 60
        });
      }

      if (parsedValue === parseInt(oldValue, 10)) {
        setEditWorkOrderItem({ id: '', key: '', value: '' });
        return;
      }

      updateShipQuantity({ newValue: parsedValue, oldValue, data });
      setEditWorkOrderItem({ id: '', key: '', value: '' });
    }
  };

  const handleKeyDown = (e, data) => {
    e.stopPropagation();

    if (e.key === 'Enter') {
      const { value } = e.target || {};
      const { id, key, value: oldValue } = editWorkOrderItem || {};
      handleSave(id, key, value, oldValue, data);
    }
  };

  const updateShipQuantity = (params) => {
    const { newValue, oldValue, data } = params || {};
    const { work_order_items_v2s, warehouse_stock = 0, id, products_v2 } = data || {};
    const { id: order_item_id } = work_order_items_v2s?.[0] || {};


    if (!newValue || isNaN(newValue) || (newValue <= 0) || (String(newValue).trim() === '') || (newValue === oldValue)) {
      notification.warning({
        message: 'Please enter a valid ship quantity!',
        top: 60
      });
      return false;
    }

    const index = findIndex(orderItems, (item) => item?.id === id);

    setUpdatingShipQtyRowId(order_item_id);
    dispatch(UpdateShipQuantity({
      work_order_item_id: order_item_id,
      ship_quantity: newValue
    })).then(({ payload }) => {
      // Backend rejection (e.g. ship qty < boxed qty) is surfaced via the slice's
      // handleRejectedResponse — no need to fire a second toast here.
      if (!payload?.success) {
        setUpdatingShipQtyRowId(null);
        return;
      }

      dispatch(updateGridShippedQty({ field: 'orderItems', index, value: newValue }));
      notification.success({
        top: 65,
        message: 'Success',
        description: 'Quantity Updated Successfully'
      });
      dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload: woPayload }) => {
        const { data: woData } = woPayload || {};
        setWorkOrderDetails({ previous: woData, current: woData });
        setUpdatingShipQtyRowId(null);
      });
    });

    return true;
  };

  const handleUpdatePrepCategory = ({ sku, prepCategory, skuId, index }) => {
    setRowIndexesForPrepCategory(rowIndexesForPrepCategory => [...rowIndexesForPrepCategory, index]);
    dispatch(UpdatePrepCategory({
      sku,
      prepCategory, skuId
    }))
      .then(({ payload }) => {
        if (!payload.success) {
          notification.error({
            top: 65,
            message: 'Prep Category Error',
            description: 'You Cannot update Prep Category'
          });
          return;
        }
        const { success } = payload || {};
        if (success) {
          dispatch(editPrepCategory({
            value: prepCategory,
            id: skuId
          }));
        }
        setRowIndexesForPrepCategory(rowIndexesForPrepCategory => rowIndexesForPrepCategory.filter((rowIndex) => rowIndex !== index));
      });
  };

  const handleUpdatePrepOwner = ({ prepOwner, skuId, index }) => {
    setRowIndexesForPrepOwner(rowIndexesForPrepOwner => [...rowIndexesForPrepOwner, index]);
    dispatch(UpdatePrepOwner({
      prepOwner, skuId
    }))
      .then(({ payload }) => {
        const { success } = payload || {};
        if (success) {
          dispatch(editPrepOwner({
            value: prepOwner,
            id: skuId
          }));
        }
        setRowIndexesForPrepOwner(rowIndexesForPrepOwner => rowIndexesForPrepOwner.filter((rowIndex) => rowIndex !== index));
      });
  };

  // Label Owner works like Prep Owner: value lives on seller_skus.label_owner (synced from
  // Amazon's listPrepDetails, NULL shown as SELLER) and a manual change persists to the database.
  // The row's dropdown is disabled only while its own save is in flight.
  const handleUpdateLabelOwner = ({ labelOwner, skuId }) => {
    setSavingLabelOwnerSkuIds(prev => [...prev, skuId]);
    dispatch(UpdateLabelOwner({
      labelOwner, skuId
    }))
      .then(({ payload }) => {
        const { success } = payload || {};
        if (success) {
          dispatch(editLabelOwner({
            value: labelOwner,
            id: skuId
          }));
        }
        setSavingLabelOwnerSkuIds(prev => prev.filter((id) => id !== skuId));
      });
  };

  const disabledDate = (current) => {
    const today = dayjs().startOf('day');
    const minValidDate = today.add(105, 'day');

    return current.isBefore(today, 'day') && current.isBefore(minValidDate, 'day');
  };

  const columnDefs = useMemo(() => [
    {
      headerName: '',
      width: 75,
      field: 'action',
      checkboxSelection: false,
      headerCheckboxSelection: false,
      cellRenderer: 'agGroupCellRenderer',
      suppressRowClickSelection: true,
      headerClass: 'parent-header',
      valueGetter: ({ data }) => data?.products_v2?.length || 0
    },
    {
      children: [{
        headerCheckboxSelection: true,
        width: 35,
        checkboxSelection: true,
        sortable: false
      }]
    },
    {
      headerName: 'Product Name',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 214,
          flex: 1,
          cellRenderer: ({ data }) => {
            const { item_name, image_url } = data || {};

            return (
              <div className='card-wrapper'>
                <img style={{ width: '50px', height: '50px', objectFit: 'contain', maxWidth: '50px' }}
                  src={image_url || ProductImg}
                  alt="ProductImg"
                  title="ProductImg"
                />
                <span className='two-line-ellipsis'>
                  {item_name || '---'}
                </span>
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'SKU/ASIN',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 180,
          flex: 1,
          cellRenderer: ({ data }) => {
            const { sku, vendorasin } = data || {};

            return (
              <Box display="flex" flexDirection="column">
                <Typography component='span' fontSize='14px' className='upc-code'><Typography component='span' fontSize='14px' color="#7E8A90">SKU:</Typography> {sku || '---'}</Typography>
                <Typography component='span' fontSize='14px' className='upc-code'><Typography component='span' fontSize='14px' color="#7E8A90">ASIN:</Typography> {vendorasin?.asin || '---'}</Typography>
              </Box>
            );
          }
        }
      ]
    },
    {
      headerName: 'Amazon Stock',
      headerClass: 'parent-header-stock',
      children: [
        {
          headerName: 'Total',
          sortable: true,
          comparator: () => 0,
          filter: true,
          headerClass: 'amazon-parent-header',
          minWidth: 60,
          flex: 1,
          field: 'amazon_total',
          cellRenderer: ({ value }) => {
            return (
              <div className='edit-able-data'>
                {/* <Popover
                  title={null}
                  content={<InfoTooltipData />}
                  placement='right'>
                </Popover> */}
                <span>{value || 0}</span>
              </div>
            );
          }
        },
        {
          headerName: 'Available',
          sortable: true,
          comparator: () => 0,
          headerClass: 'amazon-parent-header',
          filter: true,
          minWidth: 75,
          field: 'amazon_available',
          flex: 1,
          cellRenderer: ({ value }) => {
            return (
              <div className='edit-able-data'>
                <span>{value || 0}</span>
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'WH Stock',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          sortable: true,
          comparator: () => 0,
          filter: true,
          minWidth: 85,
          field: 'warehouse_stock',
          flex: 1,
          cellRenderer: ({ value, data }) => {
            const lowestStock = Math.min(...data.products_v2?.map(p => Number(p.warehouse_stock)));
            return (
              <div>{value || 0}</div>
              // <div>{value > lowestStock && lowestStock > 0 ? lowestStock : value|| 0}</div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Bundle Qty',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          sortable: true,
          comparator: () => 0,
          filter: true,
          minWidth: 100,
          field: 'min_bundle_qty',
          flex: 1,
          cellRenderer: ({ value }) => {
            return (
              <div>{value || 1}</div>
            );
          }
        }
      ]
    },
    // {
    //   headerName: 'Reserved Quantity',
    //   children: [
    //     {
    //       headerName: '',
    //       headerClass: 'parent-header',
    //       sortable: true,
    //       comparator: () => 0,
    //       filter: true,
    //       minWidth: 135,
    //       field: 'reserved_qty',
    //       flex: 1,
    //       cellRenderer: ({ value }) => {
    //         return (
    //           <div>{value || 0}</div>
    //         )
    //       }
    //     }
    //   ]
    // },
    {
      headerName: 'Ship Quantity',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          sortable: true,
          comparator: () => 0,
          filter: true,
          minWidth: 110,
          flex: 1,
          field: 'work_order_items_v2s.[0].ship_quantity',
          valueGetter: ({ data }) => data?.work_order_items_v2s?.[0]?.ship_quantity || 0,
          cellRenderer: ({ data }) => {
            const { work_order_items_v2s } = data || {};
            const { id } = work_order_items_v2s?.[0] || {};
            const shipQuantity = data?.work_order_items_v2s?.[0]?.ship_quantity || 0;
            const showInput = (editWorkOrderItem?.id === id) && (editWorkOrderItem?.key === 'ship_quantity');
            const isUpdatingThisRow = updatingShipQtyRowId === id;

            return (
              <div className='edit-able-data'>
                {isUpdatingThisRow
                  ? <Spin size="small" />
                  : (showInput ? <Input
                      autoFocus={true}
                      defaultValue={newValue}
                      onKeyDown={(e) => handleKeyDown(e, data)}
                      onBlur={(e) => handleSave(id, 'ship_quantity', e.target.value, shipQuantity, data)}
                    /> :
                    <span>{shipQuantity || 0}</span>)
                }
                {status?.toLowerCase() !== 'processed' && status?.toLowerCase() !== 'done' && !isUpdatingThisRow &&
                  <BiSolidEdit
                    className={showInput ? 'increase-font' : ''}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditWorkOrderItem({ id, key: 'ship_quantity', value: shipQuantity });
                      setNewValue(String(shipQuantity));
                    }}
                  />
                }
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Expiry Date',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 180,
          flex: 1,
          editable: true,
          field: 'work_order_items_v2s.[0].expiry_date',
          cellEditor: 'agTextCellEditor',
          valueGetter: ({ data }) => data?.work_order_items_v2s?.[0]?.expiry_date || '',
          cellRenderer: ({ data, value }) => {
            const index = findIndex(orderItems, (item) => item.id === data?.id);
            // Amazon catalog flag (synced on page load): TRUE = the inbound plan will fail with
            // "Expiration date required" unless a date is set. Mark the empty picker red.
            const expiryRequired = data?.is_expiration_dated_product === true || data?.is_expiration_dated_product === 1;
            const missingRequired = expiryRequired && !value;

            return (
              <div className={`edit-able-data${missingRequired ? ' expiry-required-missing' : ''}`} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <DatePicker
                  disabled={rowIndexesForExpiryDate.includes(index)}
                  disabledDate={disabledDate}
                  allowClear={false}
                  value={value ? moment(value) : null}
                  format='YYYY-MM-DD'
                  onChange={(momentObj, dateStr) => handleExpiryDateUpdation({ expiryDate: dateStr, data, index })}
                />
                {expiryRequired && (
                  <Tooltip title={`Amazon requires an expiration date for this product${data?.product_expiration_type ? ` (${data.product_expiration_type})` : ''}`}>
                    <span style={{ color: missingRequired ? '#ff4d4f' : '#98A2B3', fontWeight: 700, cursor: 'default' }}>*</span>
                  </Tooltip>
                )}
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Gated Status',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 130,
          flex: 1,
          cellRenderer: ({ data }) => {
            const { sku_status, id } = data || {};
            const index = findIndex(orderItems, (item) => item.id === id);

            return (
              <div className='not-gated-icon-wrapper'>
                <span className={`bag-icon-gated ${sku_status === 'Gated' ? 'new-gated' : ''}`}>
                  {
                    (rowIndexesForGatedStatus.includes(index)) ? 'fetching...' : sku_status?.toLowerCase() === 'non-gated' ? 'Not Gated' : sku_status || '---'
                  }
                </span>
                <IoReload onClick={() => handleGetSkuGatedStatus({ skuId: id, index })}
                  style={rowIndexesForGatedStatus.includes(index) ? { pointerEvents: 'none' } : {}}
                />
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Error Message',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 120,
          flex: 1,
          field: 'error_msg',
          cellRenderer: ({ data, value }) => {
            const { is_errored } = data?.work_order_items_v2s?.[0] || {};
            const errorMsg = 'Ship Quantity Cannot be 0';
            return (
              <div className='expired-data-wrapper error-msg'>
                <Tooltip placement='top' title={value || data?.prep_category_error || ''}>
                  <p>{is_errored ? value || data?.prep_category_error || errorMsg || '' : value || data?.prep_category_error || ''}</p>
                </Tooltip>
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Prep Category',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 180,
          flex: 1,
          field: 'prep_category',
          cellRenderer: ({ data }) => {
            const { id: skuId, prep_category, error_msg, sku, prep_category_error = '' } = data || {};
            const index = findIndex(orderItems, (item) => item.id === skuId);
            const regex = /prep\s*(category|owner)/i;
            const hasErrorWhileCreatingPlan = regex.test(error_msg);
            const hasPredefinedError = regex.test(prep_category_error);

            const mappedPrepCategories = PREP_CATEGORIES.map(category => {
              return (
                <Option label={category} key={category} value={category}>
                  <div>{category}</div>
                </Option>
              );
            });

            return (
              <div className='expired-data-wrapper'>
                <Select
                  key="prep_category"
                  showSearch={true}
                  disabled={!(hasErrorWhileCreatingPlan || hasPredefinedError) || rowIndexesForPrepCategory.includes(index)}
                  optionFilterProp="label"
                  placeholder="Select Category"
                  onChange={(value) => handleUpdatePrepCategory({ sku, prepCategory: value, skuId, index })}
                  value={prep_category}
                >
                  {mappedPrepCategories}
                </Select>
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Prep Owner',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 160,
          flex: 1,
          field: 'prep_owner',
          cellRenderer: ({ data }) => {
            const { id: skuId, prep_owner } = data || {};
            const index = findIndex(orderItems, (item) => item.id === skuId);

            const mappedPrepOwners = PREP_OWNER.map(owner => (
              <Option label={owner} key={owner} value={owner}>
                <div>{owner}</div>
              </Option>
            ));

            return (
              <div className='expired-data-wrapper'>
                <Select
                  key="prep_owner"
                  showSearch={true}
                  disabled={rowIndexesForPrepOwner.includes(index)}
                  optionFilterProp="label"
                  placeholder="Select Owner"
                  onChange={(value) => handleUpdatePrepOwner({ prepOwner: value, skuId, index })}
                  value={prep_owner || 'SELLER'}
                >
                  {mappedPrepOwners}
                </Select>
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Label Owner',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 160,
          flex: 1,
          field: 'label_owner',
          cellRenderer: ({ data }) => {
            const { id: skuId, label_owner } = data || {};

            const mappedLabelOwners = PREP_OWNER.map(owner => (
              <Option label={owner} key={owner} value={owner}>
                <div>{owner}</div>
              </Option>
            ));

            return (
              <div className='expired-data-wrapper'>
                <Select
                  key="label_owner"
                  showSearch={true}
                  disabled={savingLabelOwnerSkuIds.includes(skuId)}
                  optionFilterProp="label"
                  placeholder="Select Owner"
                  onChange={(value) => handleUpdateLabelOwner({ labelOwner: value, skuId })}
                  value={label_owner || 'SELLER'}
                >
                  {mappedLabelOwners}
                </Select>
              </div>
            );
          }
        }
      ]
    },
    {
      headerName: 'Action',
      children: [
        {
          headerName: '',
          headerClass: 'parent-header',
          minWidth: 75,
          flex: 1,
          cellRenderer: ({ data }) => {
            const { work_order_items_v2s } = data || {};
            const { id: order_item_id } = work_order_items_v2s?.[0] || {};
            const index = findIndex(orderItems, ({ work_order_items_v2s }) => work_order_items_v2s?.[0]?.id === order_item_id);

            return (
              <div className="d-flex align-items-center justify-content-center gap-2">
               
                <AiOutlineDelete onClick={() => {
                  setIsDelete(true);
                  setRowIndex(index);
                }} className='delete-icon' />

                 <BsPrinter
                  className="cursor-pointer"
                  style={{ color: '#1565d8', fontSize: '18px' }}
                  onClick={() => {
                    setSelectedItemForPrint(data);
                    setPrintQty(data?.work_order_items_v2s?.[0]?.ship_quantity || 1);
                    setShowPrintModal(true);
                  }}
                />
              </div>
            );
          }
        }
      ]
    }
  ], [orderItems, rowIndexesForGatedStatus, updatingShipQuantity, updatingShipQtyRowId, rowIndexesForExpiryDate, rowIndexesForPrepCategory, rowIndexesForPrepOwner, savingLabelOwnerSkuIds, status, editWorkOrderItem, newValue]);

  const InfoTooltipData = () => {
    return (
      <PoDetailsWrapper className='mt-0'>
        <div className='container-box'>
          <div className='items'>
            <span>On Confirmed POs</span>
            <span>0</span>
          </div>
          <div className='items'>
            <span>Warehouse Stock</span>
            <span>0</span>
          </div>
        </div>
      </PoDetailsWrapper>
    );
  };

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    setSelectedRowsCount(0);
    dispatch(GetOrderItems({
      page: newPage,
      workOrderId,
      sortBy,
      filters
    }))
      .then(() => dispatch(appendErrorMessages()));
  };

  const refreshGridClick = () => {
    if (gridColumnApi) {
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true
      });
      setSortBy({ key: '', type: '' });
    }
    setSelectedRowsCount(0);
    dispatch(GetOrderItems({
      page,
      workOrderId,
      filters
    }))
      .then(() => {
        dispatch(updateState({ key: 'invalidSkuMap', value: [] }));
        dispatch(appendErrorMessages());
        dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
          const { data } = payload || {};
          setWorkOrderDetails({ previous: data, current: data });
        });
      });
  };

  const handleDeleteOrderItem = () => {
    const orderItemId = orderItems?.[rowIndex]?.work_order_items_v2s?.[0]?.id;
    dispatch(DeleteOrderItem(orderItemId))
      .then(({ payload }) => {
        const { success } = payload || {};
        if (success) {
          setIsDelete(false);
          setSelectedRowsCount(0);
          dispatch(GetOrderItems({
            workOrderId,
            page,
            sortBy,
            filters
          }))
            .then(() => dispatch(appendErrorMessages()));
          dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
            const { data } = payload || {};
            setWorkOrderDetails({ previous: data, current: data });
          });
        }
      });
  };

  const handleChangeOrderDetails = ({ key, value }) => {
    setWorkOrderDetails(workOrderDetails => ({
      ...workOrderDetails,
      current: {
        ...workOrderDetails?.current,
        [key]: value
      }
    }));
  };

  const getSaveBtnDisabledStatus = () => {
    const { previous, current } = workOrderDetails || {};

    if (!trim(current?.order_name)) return true;
    if (!current?.address_id) return true;
    if (
      (previous?.order_name === trim(current?.order_name)) &&
      (trim(previous?.notes) === trim(current?.notes)) &&
      (previous?.address_id === current?.address_id)
    ) return true;

    return false;
  };

  const handleSaveOrderDetails = () => {
    dispatch(UpdateOrderDetails({
      workOrderId, data: { order_name, notes, address_id }
    }))
      .then(({ payload }) => {
        const { success } = payload || {};
        if (success) {
          setWorkOrderDetails(workOrderDetails => ({
            ...workOrderDetails,
            previous: {
              ...workOrderDetails?.current
            }
          }));
        }
      });
  };

  const handlePrintLabels = async () => {
    if (syncingSkuFullInfo) return;
    if (!printQty || Number(printQty) <= 0) {
      notification.error({
        message: 'Invalid Quantity',
        description: 'Please enter a valid number of units to print (greater than 0).'
      });
      return;
    }



    const { id: skuId } = selectedItemForPrint || {};

    let updatedItem = selectedItemForPrint;

    await dispatch(SyncSkuFullInfo({ workOrderId, skuId })).then(({ payload }) => {

      if (payload?.success) {
        updatedItem = payload.data;
      }
    });

    const {
      sku,
      vendorasin,
      work_order_items_v2s,
      products_v2,
      item_name,
      prepinstruction,
      label_owner
    } = updatedItem || {};

    const originalExpiryDate = selectedItemForPrint?.work_order_items_v2s?.[0]?.expiry_date;
    const { expiry_date = originalExpiryDate } = work_order_items_v2s?.[0] || {};

    const { username } = storeWorkOrderDetails || {};

    const title = item_name || vendorasin?.name || products_v2?.[0]?.name || sku || '---';
    const fnsku = updatedItem?.fnsku || vendorasin?.fnsku || products_v2?.[0]?.fnsku || products_v2?.[0]?.identifier_value || sku;
    const prep_instructions = prepinstruction || products_v2?.[0]?.prep_instructions || 'None';
    const bundle_quantity = products_v2?.[0]?.product_sku_mappings_v2?.bundle_quantity || 1;

    // Amazon label owner NONE -> the item ships on its manufacturer barcode; no FNSKU label.
    const effectiveLabelOwner = label_owner ?? selectedItemForPrint?.label_owner;
    if (isFnskuLabelSuppressed(effectiveLabelOwner)) {
      notifyFnskuLabelSuppressed(title || sku);
      setShowPrintModal(false);
      setPrintQty(1);
      setSelectedItemForPrint(null);
      return;
    }

    const labelsData = {
      fnsku,
      title,
      expiryDate: expiry_date ? moment(expiry_date).format('MM-DD-YYYY') : 'N/A',
      bundleQty: bundle_quantity,
      numberOfLabels: Number(printQty),
      username: username || "Opulent",
      prepInstruction: prep_instructions,
      labelOwner: effectiveLabelOwner,
    };


    productLabel(labelsData);
    setShowPrintModal(false);
    setPrintQty(1);
    setSelectedItemForPrint(null);
  };


  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null);

    if (value && ['warehouse_stock', 'amazon_total', 'amazon_available', 'reserved_qty', 'ship_quantity', 'min_bundle_qty'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      setSelectedRowsCount(0);
      dispatch(GetOrderItems({
        page,
        workOrderId,
        filters,
        sortBy: { key: colId, type: sort }
      }))
        .then(() => dispatch(appendErrorMessages()));
    }
  };

  const handleSearch = debounce((value) => {
    if (trim(value) || filters.search) {
      setFilters(filters => ({ ...filters, search: value }));
      setPage(page => ({ ...page, pageNumber: 1 }));
      setSelectedRowsCount(0);
      dispatch(GetOrderItems({
        workOrderId,
        page: { ...page, pageNumber: 1 },
        filters: { ...filters, search: value },
        sortBy
      }))
        .then(() => dispatch(appendErrorMessages()));
    }
  }, 800);

  const handleCreateInboundPlan = (actualPlan) => {
    dispatch(CreateInboundPlan({ workOrderId, actualPlan, packingMethod, shipmentType }))
      .then(({ payload }) => {
        const { invalidSkus, success } = payload || {};

        if (!isEmpty(invalidSkus)) {
          dispatch(GetOrderItems({
            workOrderId,
            page: { ...page, pageNumber: 1 },
            filters: { ...filters },
            sortBy
          }))
            .then(() => dispatch(appendErrorMessages()));
        }
        else if (success) {
          if (actualPlan) {
            if (packingMethod === 'pack_now') {
              notification.success({
                message: 'Inbound Plan Confirmed',
                description: 'The work order has been confirmed. Warehouse team can now process it.',
                top: 65,
              });
              // Pack Now: navigate to shipping if role is 5, else to confirm placement
              if (currentUser?.role?.id === 5) {
                navigate(`/shipping/${workOrderId}`, { replace: true });
              } else {
                navigate(`/confirm-placement/${workOrderId}`);
              }
            } else {
              // Pack Later: navigate to placement options
              navigate(`/placement-option/${workOrderId}`);
            }
          }
        };
      });
  };

  useEffect(() => {

    dispatch(updateState({ key: 'actualPlan', value: true }));
  }, []);

  const handleExportAll = () => {
    dispatch(GetOrderItems({
      workOrderId,
      exportAll: true
    })).then(({ payload }) => {
      if (payload.success == true) {
        console.log({
          payload
        });
        handleExportOrderItems(payload.data);
      }
    });
  };

  const gridReady = (params) => {
    gridApi = params.api;
    gridColumnApi = params.columnApi;
  };

  const handleExportOrderItems = (data) => {
    let sortedSelectedRows;

    if (isArray(data)) {
      sortedSelectedRows = data;
    }
    if (sortedSelectedRows.length === 0) {
      notification.error({
        top: 65,
        message: 'Export Order Item(s)',
        description: 'Please select at least one row to export.'
      });
      return;
    }

    const mappedData = sortedSelectedRows?.map((orderItem) => {
      const {
        sku,
        work_order_items_v2s
      } = orderItem || {};

      console.log({
        work_order_items_v2s
      });
      const filteredOrderItem = orderItems.find((item) => item.id === orderItem.id );

      return {
        'Sku': sku || '',
        'Expiry Date': work_order_items_v2s?.[0]?.expiry_date || '',
        'Quantity': work_order_items_v2s?.[0]?.ship_quantity || 0,
        'Error': filteredOrderItem?.error_msg || filteredOrderItem?.prep_category_error || ''
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Work Order');

    XLSX.writeFile(workbook, `Work Order-${order_name}.xlsx`);
  };

  const handleBulkDeleteItems = () => {
    if (bulkDeletingOrderItems) return;
    if (['Confirmed', 'In Progress', 'Done'].includes(status)) {
      notification.error({
        top: 65,
        message: 'Bulk Delete Order Items',
        description: 'You cannot delete order items in Confirmed, In Progress or Done status.'
      });
      return;
    }
    const selectedRows = gridApi.getSelectedRows();
    if (!orderItems?.length || selectedRows.length === 0) {
      notification.error({
        top: 65,
        message: 'Bulk Delete Order Items',
        description: 'Please select at least one row.'
      });
      return;
    }

    const orderItemIds = selectedRows?.map(({ work_order_items_v2s }) => work_order_items_v2s[0]?.id) || [];

    dispatch(BulkDeleteOrderItems({
      orderItemIds
    }))
      .then(() => {
        setIsDeleteBulk(false);
        setSelectedRowsCount(0);
        dispatch(GetOrderItems({
          workOrderId,
          page,
          sortBy,
          filters
        }))
          .then(() => {
            dispatch(appendErrorMessages());
            dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
              const { data } = payload || {};
              setWorkOrderDetails({ previous: data, current: data });
            });
          }
          );
      });
  };

  const handleOpenMoveModal = () => {
    if (['Confirmed', 'In Progress', 'Done'].includes(status)) {
      notification.warning({
        top: 60,
        message: 'Cannot Move',
        description: 'Only Draft work orders support moving items.'
      });
      return;
    }
    const selectedRows = gridApi.getSelectedRows();
    if (!orderItems?.length || selectedRows.length === 0) {
      notification.error({ top: 65, message: 'Move Items', description: 'Please select at least one row.' });
      return;
    }
    setBulkExpiry(false);
    dispatch(GetDraftWorkOrdersForMove({ workOrderId }));
    setIsMove(true);
  };

  const handleMoveConfirm = ({ targetWorkOrderId, orderName }) => {
    const selectedRows = gridApi.getSelectedRows();
    const orderItemIds = selectedRows.map(r => r.work_order_items_v2s?.[0]?.id).filter(Boolean);
    if (!orderItemIds.length) return;

    dispatch(MoveOrderItems({ orderItemIds, targetWorkOrderId, orderName })).then(({ payload }) => {
      if (payload?.success) {
        setIsMove(false);
        setSelectedRowsCount(0);
        dispatch(GetOrderItems({ workOrderId, page, sortBy, filters })).then(() => {
          dispatch(appendErrorMessages());
          dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload: detailsPayload }) => {
            const { data } = detailsPayload || {};
            setWorkOrderDetails({ previous: data, current: data });
          });
        });
      }
    });
  };

  const getInboundPlanBtnDisabledStatus = () => {
    const hasError = orderItems?.some(item =>
      item.work_order_items_v2s?.some(workOrder => workOrder?.is_errored === true)
    );
    return !workOrderDetails?.current?.address_id || updatingOrderDetails || bulkExpiryLoading || fetchingPlacementOptions || fetchingShipmentItems || updatingShipQuantity || deletingOrderItem || bulkDeletingOrderItems || updatingPrepCategory || creatingInboundPlan || !orderItems?.length || ['Confirmed', 'In Progress', 'Done'].includes(status) || hasError;
  };

  const onSelectionChange = () => {
    setSelectedRowsCount(gridApi?.getSelectedRows?.()?.length || 0);
  };

  const getBulkDeleteDisabledStatus = () => {
    return bulkDeletingOrderItems || ['Confirmed', 'In Progress', 'Done'].includes(status) || !orderItems?.length || !gridApi.getSelectedRows()?.length;
  };

  const { pageNumber, pageSize } = page || {};

  const debouncedSave = useCallback(
    debounce(() => {
      if (!order_name) return; // Don't save if order_name is empty
      if (order_name || notes) {
        if (workOrderDetails?.current?.address_id !== workOrderDetails?.previous?.address_id || workOrderDetails?.current?.order_name !== workOrderDetails?.previous?.order_name || workOrderDetails?.current?.notes !== workOrderDetails?.previous?.notes) {
          handleSaveOrderDetails();
        }
      }
    }, 1000),
    [order_name, notes, address_id]
  );

  useEffect(() => {
    debouncedSave();
    return () => debouncedSave.cancel();
  }, [order_name, notes, address_id, debouncedSave]);

  return (
    <CreateInventoryWorkOrderWrapper>
      <header>
        <Spin tip='Loading...' spinning={fetchingWorkOrderDetails}>
          <Box display="grid" gridTemplateColumns="2.2fr 0.8fr 1fr 1fr 2fr 1.5fr 1.5fr" alignItems="end" gap={2}>
            <Input
              className="inputs"
              label="Order Name"
              placeholder="Order Name here"
              value={order_name}
              onChange={({ target }) => handleChangeOrderDetails({ key: 'order_name', value: target?.value })}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (!order_name) return;
                  handleSaveOrderDetails();
                }
              }}
            />
            <div className='items'>
              <label>Status</label>
              <Badge circleStatus status={capitalize(status) || ''} />
            </div>
            <Input
              className="inputs"
              label="Total Shipment Quantity"
              disabled
              placeholder="Ship Qty"
              value={storeWorkOrderDetails?.total_ship_qty || '0'}
            />
            <Input
              className="inputs"
              label="Type"
              disabled
              placeholder="Ship to FBA"
              value={order_type}
            />
            <AddressSelector
              addresses={mappedWarehouseAddresses}
              selectedAddress={address_id ? mappedWarehouseAddresses.find(option => option.value === address_id) : null}
              onAddressChange={({ value }) => handleChangeOrderDetails({ key: 'address_id', value })}
              onAddNewClick={() => {
                setAddressIndex(-1);
                setAddressModal(true);
              }}
              label="Ship From Address"
              placeholder="Select"
              optionButtonText="+ Add New Address"
              onEditClick={handleEditClick}
            />
            <Box>
              <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 13 }}>Shipment Type</label>
              <Radio.Group
                value={shipmentType}
                onChange={(e) => {
                  setShipmentType(e.target.value);
                  if (e.target.value === 'SP') setPackingMethod('pack_now');
                }}
              >
                <Radio value="SP">SPD</Radio>
                <Radio value="LTL">LTL</Radio>
              </Radio.Group>
            </Box>
            <Box>
              <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 13 }}>Packing Method</label>
              <Radio.Group
                value={packingMethod}
                onChange={(e) => setPackingMethod(e.target.value)}
              >
                <Radio value="pack_now">Now</Radio>
                <Radio value="pack_later" disabled={shipmentType === 'SP'}>Later</Radio>
              </Radio.Group>
            </Box>
          </Box>
          {/* <Input
            className="inputs"
            overlayClassName="additional-note-input"
            as="textarea"
            label="Additional Note"
            placeholder="Enter"
            value={notes}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (!notes?.trim()) return;
                handleSaveOrderDetails();
              }
            }}
            onChange={({ target }) => handleChangeOrderDetails({ key: 'notes', value: target?.value })}
          /> */}
        </Spin>
      </header>
      <div>
        <section>
          <Stack direction="row" spacing={1.5} alignItems={'center'}>
            <SearchInput
              className="search work-order-search-bar"
              placeholder="Search by Title / ASIN / SKU / UPC"
              onChange={({ target }) => handleSearch(target.value)}
            />
          </Stack>
          <Box display="flex" gap={2}>
            <Popconfirm
              placement="left"
              title="Are you sure you want to delete selected item(s)?"
              okText="Yes"
              cancelText="No"
              onConfirm={handleBulkDeleteItems}
            >

            </Popconfirm>
            <Popover
              content={bulkExpiryContent}
              trigger="click"
              placement="bottom"
              arrowPointAtCenter={true}
              visible={bulkExpiry}
              overlayClassName='bulk-expiry-popover'
              onVisibleChange={handleVisibleBulkExpiryChange}
            >
              <Popover
                content={content}
                trigger="click"
                placement="bottomRight"
                visible={popoverVisible}
              >
                <Button
                  text="bulk action"
                  className="outlined mb-0"
                  endIcon={<FaChevronDown />}
                  minWidth="90px"
                />
              </Popover>
            </Popover>
            <Button
              text="Move"
              className="outlined mb-0"
              startIcon={<AiOutlineSwap />}
              minWidth="90px"
              disabled={!selectedRowsCount}
              onClick={handleOpenMoveModal}
            />
            {/* <Button
              text="Export"
              className="outlined mb-0"
              startIcon={<span className="icon-add pr-8"></span>}
              disabled={!orderItems?.length}
              minWidth="90px"
              onClick={() => handleExportAll()}
            /> */}
            <Button
              text="Add SKU"
              className="outlined mb-0"
              startIcon={<span className="icon-add pr-8"></span>}
              minWidth="90px"
              onClick={() => setAddSku(true)}
            />
            {/* <Button
              text="Save"
              className="outlined mb-0"
              minWidth="90px"
              disabled={getSaveBtnDisabledStatus()}
              onClick={handleSaveOrderDetails}
            /> */}
            <Button
              text="Check Inbound Errors"
              className="primary mb-0"
              minWidth="90px"
              onClick={() => {
                dispatch(updateState({ key: 'invalidSkuMap', value: [] }));
                dispatch(appendErrorMessages());
                dispatch(updateState({ key: 'actualPlan', value: false }));
                handleCreateInboundPlan(false);
              }}
              loading={creatingInboundPlan}
              disabled={!workOrderDetails?.current?.address_id || updatingOrderDetails || fetchingPlacementOptions || fetchingShipmentItems || bulkExpiryLoading || updatingShipQuantity || deletingOrderItem || bulkDeletingOrderItems || updatingPrepCategory || creatingInboundPlan || !orderItems?.length}
            />
            <Button
              text={packingMethod === 'pack_now' ? 'Transfer to Warehouse' : 'Create Inbound Plan'}
              className="primary mb-0"
              minWidth="90px"
              style={packingMethod === 'pack_now' ? { backgroundColor: '#52c41a', borderColor: '#52c41a' } : {}}
              onClick={() => {
                dispatch(updateState({ key: 'invalidSkuMap', value: [] }));
                dispatch(appendErrorMessages());
                dispatch(updateState({ key: 'actualPlan', value: true }));
                handleCreateInboundPlan(true);
              }}
              loading={creatingInboundPlan}
              disabled={getInboundPlanBtnDisabledStatus()}
            />
          </Box>
        </section>
        <Spin tip={syncingSkuFlags ? 'Loading...' : 'Loading...'} spinning={deletingOrderItem || creatingInboundPlan || bulkDeletingOrderItems || fetchingOrderItems || syncingSkuFlags || fetchingPlacementOptions || fetchingShipmentItems}>
          <AgGrid
            gridReady={gridReady}
            user_referrals={orderItems}
            defaultColDef={defaultColDef}
            columnDefinitions={columnDefs}
            gridOptions={gridOptions}
            rowHeight={64}
            headerHeight={36}
            height="386px"
            rowSelection="multiple"
            masterDetail={true}
            detailRowAutoHeight={true}
            onSortChange={onSortChange}
            onSelectionChanged={onSelectionChange}
            detailCellRenderer={(props) => <WorkRowDetails
              {...props}
            />}
            className="sku-table"
          />
          <Pagination
            total={orderItemsCount}
            totalPages={ceil(orderItemsCount / pageSize + 1)}
            pageNumber={pageNumber}
            pageLimit={pageSize}
            handleLimitChange={(e) => handlePagination(e, 'pageSize')}
            handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
            handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
            handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
            refreshGridClick={refreshGridClick}
            loading={fetchingSkuGatedStatus}
          />
        </Spin>

        {
          addSku &&
          <AddSkuDrawer addSku={addSku} setAddSku={setAddSku} workOrderId={workOrderId} />
        }

        {isMove && (
          <MoveItemsModal
            open={isMove}
            onClose={() => setIsMove(false)}
            onConfirm={handleMoveConfirm}
            selectedItems={gridApi?.getSelectedRows?.() || []}
            eligibleTargetWorkOrders={draftWorkOrdersForMove}
            fetchingTargets={fetchingDraftWorkOrdersForMove}
            loading={movingOrderItems}
          />
        )}

        <Modal
          open={isDelete}
          onClose={() => setIsDelete(false)}
          onHide={() => setIsDelete(false)}
          closeText='Cancel'
          saveText={'Confirm'}
          header='Delete Confirmation'
          className='delete-confirmation-modal'
          closeButton={true}
          onSave={handleDeleteOrderItem}
          buttonDisabled={deletingOrderItem}
        >
          <ModalWrapper>
            <div className='delete-modal-wrapper'>
              <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
              <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
              <p>Are you sure you want to delete this <b>SKU ({orderItems?.[rowIndex]?.sku})</b>?</p>
              {Number(orderItems?.[rowIndex]?.multi_sku_box_count) > 0 && (
                <p>
                  This SKU is part of {orderItems[rowIndex].multi_sku_box_count} multi-SKU box(es). The related box(es) will be removed and need to be repacked.
                </p>
              )}
            </div>
          </ModalWrapper>
        </Modal>
        <Modal
          open={isDeleteBulk}
          onClose={() => setIsDeleteBulk(false)}
          onHide={() => setIsDeleteBulk(false)}
          closeText='Cancel'
          saveText={bulkDeletingOrderItems ? 'Deleting' : 'Yes'}
          className='delete-confirmation-modal'
          closeButton={true}
          size="md"
          onSave={() => {
            handleBulkDeleteItems();
          }}
        >
          <ModalWrapper className='delete-confirmation-modal-se'>
            <div className='delete-modal-wrapper'>
              <img src={DeleteIcon} alt='DeleteIcon' title='DeleteIcon' />
              <p>Are you sure you want to delete <span className='count-text-se'>{selectedRowsCount}</span>  items.</p>
              {bulkDeleteRows?.some(row => Number(row?.multi_sku_box_count) > 0) && (
                <p>
                  One or more selected SKUs are part of multi-SKU box(es). The related box(es) will be removed and need to be repacked.
                </p>
              )}
            </div>
          </ModalWrapper>
        </Modal>

        <CustomAntdModal
          visible={isBulkExpiry}
          saveText={bulkExpiryLoading ? 'Saving' : 'Save'}
          okText={bulkExpiryLoading ? 'Saving' : 'Save'}
          cancelText='Cancel'
          onClose={() => {
            setBulkExpiryDate('');
            setIsBulkExpiry(false);
          }
          }
          onCancel={() => {
            setIsBulkExpiry(false);
            setBulkExpiryDate('');
          }}
          onSave={() => {
            handleBulkExpiryDate();
          }}
          width={417}
        >
          <ModalWrapper className='bulk-expiry-modal'>
            <h6>Bulk Expiry</h6>
            <DatePicker
              value={
                bulkExpiryDate ? moment(bulkExpiryDate) : null
              }
              onChange={(date, dateString) =>
                setBulkExpiryDate(dateString)
              }
            />
          </ModalWrapper>
        </CustomAntdModal>

        <Modal
          open={showPrintModal}
          onClose={() => {
            setShowPrintModal(false);
            setSelectedItemForPrint(null);
          }}
          onHide={() => {
            setShowPrintModal(false);
            setSelectedItemForPrint(null);
          }}
          closeText="Cancel"
          saveText="Print"
          header="Print FNSKU Labels"
          closeButton={true}
          onSave={handlePrintLabels}
          buttonDisabled={syncingSkuFullInfo}
        >
          <Spin spinning={syncingSkuFullInfo} tip="Syncing with Amazon...">
            <ModalWrapper>
              <Box display="flex" flexDirection="column" gap={2} padding={2}>
                <Typography variant="body1">
                  Enter number of units to print for <b>{selectedItemForPrint?.sku}</b>
                </Typography>
                <Input
                  type="number"
                  placeholder="Number of units"
                  value={printQty}
                  onChange={(e) => setPrintQty(e.target.value)}
                  min={1}
                />
              </Box>
            </ModalWrapper>
          </Spin>
        </Modal>

      </div>

      {
        addressModal &&
        <AddressModal
          showModal={addressModal}
          setShowModal={setAddressModal}
          addressIndex={addressIndex}
          setAddressIndex={setAddressIndex}
          warehouseAddresses={warehouseAddresses}
          changeAddress={value => handleChangeOrderDetails({ key: 'address_id', value })}
        />
      }
    </CreateInventoryWorkOrderWrapper>
  );
};

export default CreateInventoryWorkOrder;
